// src/hooks/hotelMealPlans/useDeleteAllHotelMealPlans.js
import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { deleteAllHotelMealPlans as deleteAllHotelMealPlansAPI } from "../../api/apiHotelMealPlans";
import parseError from "../../utils/parseError";

const useDeleteAllHotelMealPlans = () => {
    const queryClient = useQueryClient();

    const { mutate: deleteAll, isPending: isDeleteAll } = useMutation({
        mutationFn: deleteAllHotelMealPlansAPI,
        onSuccess: (res) => {
            const message = res?.message || "Selected hotel meal plans deleted successfully";
            toast.success(message);
            queryClient.invalidateQueries({ queryKey: ["hotelMealPlans"] });
        },
        onError: (error) => {
            const msg = parseError(error);
            toast.error(msg || "Failed to delete selected hotel meal plans");
        },
    });

    return { deleteAllHotelMealPlans: deleteAll, isDeleteAll };
};

export default useDeleteAllHotelMealPlans;
